import React from "react";
import PrimaryDeviceInformationForm from "./PrimaryDeviceInformationForm";
import PrimaryDeviceInformationPreview from "./PrimaryDeviceInformationPreview";
import { Grid } from "@mui/material";
import { Edit as EditIcon } from "@mui/icons-material";

const PrimaryDeviceInformation = ({
  isLoading,
  isEditMode,
  handleSubmit,
  setIsEditMode,
  currentUserRole,
  deviceInformation,
  handleCancelClick,
  hasIncompleteRpmInformation,
  deviceInformationEditAccessRoles,
}) => {
  return (
    <div>
      <Grid container style={{ marginTop: "20px" }}>
        <Grid item xs={11} style={{ textAlign: "left", marginBottom: "5px" }}>
          <div className="device-info__device-title">PRIMARY DEVICE</div>
        </Grid>

        {!isEditMode &&
          deviceInformationEditAccessRoles.includes(currentUserRole) && (
            <Grid item xs={1} style={{ textAlign: "right" }}>
              <span
                class="device-edit-button"
                onClick={() => setIsEditMode(true)}
              >
                <EditIcon
                  className="patient-edit-icon billing-cycle-edit-icon"
                  data-action="edit-primary-device-information-icon"
                />
                Edit
              </span>
            </Grid>
          )}
      </Grid>

      {isEditMode ? (
        <PrimaryDeviceInformationForm
          isPrimaryDevice={true}
          handleCancelClick={() => handleCancelClick(true)}
          handleSubmit={handleSubmit}
          isLoading={isLoading}
        />
      ) : (
        <PrimaryDeviceInformationPreview currentDevice={deviceInformation} />
      )}
    </div>
  );
};

export default PrimaryDeviceInformation;
